import PropTypes from "prop-types";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./CustomTooltip.scss";

const CustomTooltip = ({
  text,
  children,
  classString,
  placement,
  disabled = 0,
}) => {
  let tooltipContainer = null;

  if (classString) {
    tooltipContainer =
      typeof classString === "string"
        ? document.querySelector(classString)
        : classString;
  }

  // const renderTooltip = (props) => (
  //   <Tooltip
  //     id="tooltip"
  //     style={{
  //       display: disabled ? "none" : "block",
  //     }}
  //   >
  //     {props}
  //   </Tooltip>
  // );

  const renderTooltip = (props) => (
    <Tooltip
      {...props}
      id="tooltip"
      className="custom-tooltip-black"
      style={{
        display: disabled ? "none" : "block",
      }}
    >
      {text}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      disabled
      placement={placement ?? "top"}
      overlay={renderTooltip(text)}
      container={tooltipContainer}
    >
      {children}
    </OverlayTrigger>
  );
};

CustomTooltip.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  classString: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  placement: PropTypes.string,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default CustomTooltip;
